import { post, get } from '@/utils/request'

// 新增需求
export function addDemand(data = {}) {
  return post({
    url: '/assistant/supply/demand/addDemand',
    data,
  })
}

// 根据名称查询
export function getMaterialByName(data) {
  return get({
    url: '/assistant/pubingredient/etDimIngredient/getByName',
    data,
  })
}

// 获取包材产品类型
export function getPkgProductTypes() {
  return get({
    url: `/assistant/tkradar/dictData/getDictByType?dictTypes=tkpc_pkg_category_type`,
  })
}

// 获取包材产品材质
export function getPkgProductMaterial() {
  return get({
    url: `/assistant/tkradar/dictData/getDictByType?dictTypes=tkpc_pkg_product_material`,
  })
}

//  获取阿里云配置
export const getOssConfig = () => {
  return get({
    url: '/assistant/system/oss/getOssConfigByKey',
  })
}

// 获取用户联系信息
export function getInfo() {
  return post({
    url: '/assistant/user/contact/getInfo',
  })
}

// 更新用户联系信息
export function updateInfo(data = {}) {
  return post({
    url: '/assistant/user/contact/updateInfo',
    data,
  })
}